import { createImageVariantConfig, types as sdkTypes } from '../../util/sdkLoader';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { storableError } from '../../util/errors';
import { fetchStripeAccount } from '../../ducks/stripeConnectAccount.duck';
import { isBookingProcessAlias } from '../../transactions/transaction';
import { getDefaultTimeZoneOnBrowser, getStartOf, getStartOfWeek, monthIdString, parseDateFromISO8601, stringifyDateToISO8601 } from '../../util/dates';
import { createSlug, getAlgoliaIndexNameForLang, parse } from '../../util/urlHelpers';
import { uniqueBy } from '../../util/generators';
import { cancelUpcomingMail, createAlgoliaData, enhanceField, generateAIImages, generateBlogs, generateBlogTitleswithLabels, sendSMSNotification, syncListingAlgolia, updateCloudinaryContext, userActiveListings, deleteImage } from '../../util/api';
import { buildListingImageSeoTags, buildListingVideoSeoTags } from '../../util/imageSeoTags';
import { denormalisedResponseEntities, isUploadedInstructionVideo, urlToFile } from '../../util/data';
import { v4 as uuid4 } from 'uuid';
import { UploadImage, UploadVideo } from '../../util/cloudinary';
import { getCredits } from '../../util/api';
import { IS_DEVELOPMENT_ENV, LISTING_ALOGLIA_REMOVABLE_FIELDS } from '../../util/constants';
import moment from 'moment';
import { filterUserPublicDataForAlgolia, filterListingUserPublicDataForAlgolia, filterPublicDataToAlgolia } from '../../util/algoliaHelpers';
import {
    getBlogsByListingId,
    updateBlogPost,
    deleteBlogPost,
    publishBlogPost,
    retryBlogTranslations,
} from '../../util/api';
import { getAdminConfig } from '../TransactionPage/TransactionPage.duck';

const { UUID } = sdkTypes;
const listingSmsNotificationContentSid = process.env.REACT_APP_TWILIO_listing_is_live_en;

const getImageVariantInfo = listingImageConfig => {
    const {
        aspectWidth = 1,
        aspectHeight = 1,
        variantPrefix = 'listing-card',
    } = listingImageConfig;
    const aspectRatio = aspectHeight / aspectWidth;
    const fieldsImage = [
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
    ];

    return {
        fieldsImage,
        imageVariants: {
            ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
            ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
        },
    };
};

// When navigating through weekly calendar,
// we want to merge new week-related data (inProgres, error) to weeklyExceptionQueries hashmap.
const mergeToWeeklyExceptionQueries = (
    weeklyExceptionQueries,
    weekStartId,
    newDataProps
) => {
    return weekStartId
        ? {
            weeklyExceptionQueries: {
                ...weeklyExceptionQueries,
                [weekStartId]: {
                    ...weeklyExceptionQueries[weekStartId],
                    ...newDataProps,
                },
            },
        }
        : {};
};

// When navigating through monthly calendar (e.g. when adding a new AvailabilityException),
// we want to merge new month-related data (inProgres, error) to monthlyExceptionQueries hashmap.
const mergeToMonthlyExceptionQueries = (
    monthlyExceptionQueries,
    monthId,
    newDataProps
) => {
    return monthId
        ? {
            monthlyExceptionQueries: {
                ...monthlyExceptionQueries,
                [monthId]: {
                    ...monthlyExceptionQueries[monthId],
                    ...newDataProps,
                },
            },
        }
        : {};
};


const getArrayOfNItems = n =>
    Array(n)
        .fill()
        .map((v, i) => i + 1)
        .slice(1);

// ================ Action types ================ //
export const GET_CREDITS_REQUEST = 'app/AIUpdateListingPage/GET_CREDITS_REQUEST';
export const GET_CREDITS_SUCCESS = 'app/AIUpdateListingPage/GET_CREDITS_SUCCESS';
export const GET_CREDITS_ERROR = 'app/AIUpdateListingPage/GET_CREDITS_ERROR';

export const FETCH_LISITNG_REQUESTED = 'app/AIUpdateListingPage/FETCH_LISITNG_REQUESTED';
export const FETCH_LISTING_SUCCESS = 'app/AIUpdateListingPage/FETCH_LISTING_SUCCESS';
export const FETCH_LISTING_ERROR = 'app/AIUpdateListingPage/FETCH_LISTING_ERROR';

export const FETCH_EXCEPTIONS_REQUEST = 'app/AIUpdateListingPage/FETCH_AVAILABILITY_EXCEPTIONS_REQUEST';
export const FETCH_EXCEPTIONS_SUCCESS = 'app/AIUpdateListingPage/FETCH_AVAILABILITY_EXCEPTIONS_SUCCESS';
export const FETCH_EXCEPTIONS_ERROR = 'app/AIUpdateListingPage/FETCH_AVAILABILITY_EXCEPTIONS_ERROR';

export const AIGENERATED_IMAGES_REQUESTED = 'app/AIUpdateListingPage/AIGENERATED_IMAGES_REQUESTED';
export const AIGENERATED_IMAGES_SUCCESS = 'app/AIUpdateListingPage/AIGENERATED_IMAGES_SUCCESS';
export const AIGENERATED_IMAGES_ERROR = 'app/AIUpdateListingPage/AIGENERATED_IMAGES_ERROR';

export const ENHANCE_FIELD_REQUEST = 'app/AIUpdateListingPage/ENHANCE_FIELD_REQUEST';
export const ENHANCE_FIELD_SUCCESS = 'app/AIUpdateListingPage/ENHANCE_FIELD_SUCCESS';
export const ENHANCE_FIELD_ERROR = 'app/AIUpdateListingPage/ENHANCE_FIELD_ERROR';

export const UPDATE_LISTING_REQUEST = 'app/AIUpdateListingPage/UPDATE_LISTING_REQUEST';
export const UPDATE_LISTING_SUCCESS = 'app/AIUpdateListingPage/UPDATE_LISTING_SUCCESS';
export const UPDATE_LISTING_ERROR = 'app/AIUpdateListingPage/UPDATE_LISTING_ERROR';

export const PUBLISH_LISTING_REQUEST = 'app/AIUpdateListingPage/PUBLISH_LISTING_REQUEST';
export const PUBLISH_LISTING_SUCCESS = 'app/AIUpdateListingPage/PUBLISH_LISTING_SUCCESS';
export const PUBLISH_LISTING_ERROR = 'app/AIUpdateListingPage/PUBLISH_LISTING_ERROR';

export const ADD_AVAILABILITY_EXCEPTION_REQUEST = 'app/AIUpdateListingPage/ADD_AVAILABILITY_EXCEPTION_REQUEST';
export const ADD_AVAILABILITY_EXCEPTION_SUCCESS = 'app/AIUpdateListingPage/ADD_AVAILABILITY_EXCEPTION_SUCCESS';
export const ADD_AVAILABILITY_EXCEPTION_ERROR = 'app/AIUpdateListingPage/ADD_AVAILABILITY_EXCEPTION_ERROR';

export const DELETE_AVAILABILITY_EXCEPTION_REQUEST = 'app/AIUpdateListingPage/DELETE_AVAILABILITY_EXCEPTION_REQUEST';
export const DELETE_AVAILABILITY_EXCEPTION_SUCCESS = 'app/AIUpdateListingPage/DELETE_AVAILABILITY_EXCEPTION_SUCCESS';
export const DELETE_AVAILABILITY_EXCEPTION_ERROR = 'app/AIUpdateListingPage/DELETE_AVAILABILITY_EXCEPTION_ERROR';

export const FETCH_EXTRA_EXCEPTIONS_SUCCESS = 'app/AIUpdateListingPage/FETCH_EXTRA_EXCEPTIONS_SUCCESS';

export const GENERATE_AI_IMAGES_REQUEST = 'app/AIUpdateListingPage/GENERATE_AI_IMAGES_REQUEST';
export const GENERATE_AI_IMAGES_SUCCESS = 'app/AIUpdateListingPage/GENERATE_AI_IMAGES_SUCCESS';
export const GENERATE_AI_IMAGES_ERROR = 'app/AIUpdateListingPage/GENERATE_AI_IMAGES_ERROR';
export const RESET_GENERATED_IMAGES = 'app/AIUpdateListingPage/RESET_GENERATED_IMAGES';

// Action types
const GENERATE_BLOG_TITLES_REQUEST = 'app/AIUpdateListingPage/GENERATE_BLOG_TITLES_REQUEST';
const GENERATE_BLOG_TITLES_SUCCESS = 'app/AIUpdateListingPage/GENERATE_BLOG_TITLES_SUCCESS';
const GENERATE_BLOG_TITLES_ERROR = 'app/AIUpdateListingPage/GENERATE_BLOG_TITLES_ERROR';

const GENERATE_BLOGS_REQUEST = 'app/AIUpdateListingPage/GENERATE_BLOGS_REQUEST';
const GENERATE_BLOGS_SUCCESS = 'app/AIUpdateListingPage/GENERATE_BLOGS_SUCCESS';
const GENERATE_BLOGS_ERROR = 'app/AIUpdateListingPage/GENERATE_BLOGS_ERROR';

const FETCH_BLOGS_REQUEST = 'app/AIUpdateListingPage/FETCH_BLOGS_REQUEST';
const FETCH_BLOGS_SUCCESS = 'app/AIUpdateListingPage/FETCH_BLOGS_SUCCESS';
const FETCH_BLOGS_ERROR = 'app/AIUpdateListingPage/FETCH_BLOGS_ERROR';

const UPDATE_BLOG_REQUEST = 'app/AIUpdateListingPage/UPDATE_BLOG_REQUEST';
const UPDATE_BLOG_SUCCESS = 'app/AIUpdateListingPage/UPDATE_BLOG_SUCCESS';
const UPDATE_BLOG_ERROR = 'app/AIUpdateListingPage/UPDATE_BLOG_ERROR';

const DELETE_BLOG_REQUEST = 'app/AIUpdateListingPage/DELETE_BLOG_REQUEST';
const DELETE_BLOG_SUCCESS = 'app/AIUpdateListingPage/DELETE_BLOG_SUCCESS';
const DELETE_BLOG_ERROR = 'app/AIUpdateListingPage/DELETE_BLOG_ERROR';

const PUBLISH_BLOG_REQUEST = 'app/AIUpdateListingPage/PUBLISH_BLOG_REQUEST';
const PUBLISH_BLOG_SUCCESS = 'app/AIUpdateListingPage/PUBLISH_BLOG_SUCCESS';
const PUBLISH_BLOG_ERROR = 'app/AIUpdateListingPage/PUBLISH_BLOG_ERROR';

const RETRY_BLOG_TRANSLATIONS_REQUEST =
    'app/AIUpdateListingPage/RETRY_BLOG_TRANSLATIONS_REQUEST';
const RETRY_BLOG_TRANSLATIONS_SUCCESS =
    'app/AIUpdateListingPage/RETRY_BLOG_TRANSLATIONS_SUCCESS';
const RETRY_BLOG_TRANSLATIONS_ERROR =
    'app/AIUpdateListingPage/RETRY_BLOG_TRANSLATIONS_ERROR';

const SET_DELETED_IMAGE_IDS = 'app/AIUpdateListingPage/SET_DELETED_IMAGE_IDS';
const RESET_DELETED_IMAGE_IDS = 'app/AIUpdateListingPage/RESET_DELETED_IMAGE_IDS';

const MARK_TAB_UPDATED = 'app/AIUpdateListingPage/MARK_TAB_UPDATED';
const CLEAR_UPDATED_TAB = 'app/AIUpdateListingPage/CLEAR_UPDATED_TAB';

const DISMISS_MIGRATION_BANNER_REQUEST = 'app/AIUpdateListingPage/DISMISS_MIGRATION_BANNER_REQUEST';
const DISMISS_MIGRATION_BANNER_SUCCESS = 'app/AIUpdateListingPage/DISMISS_MIGRATION_BANNER_SUCCESS';
const DISMISS_MIGRATION_BANNER_ERROR = 'app/AIUpdateListingPage/DISMISS_MIGRATION_BANNER_ERROR';

const sortExceptionsByStartTime = (a, b) => {
    return a.attributes.start.getTime() - b.attributes.start.getTime();
};

// ================ Reducer ================ //

const initialState = {
    listing: null,

    // Blog-related state
    blogs: [], // array of blog objects
    fetchBlogsInProgress: false,
    fetchBlogsError: null,
    analytics: {},

    updateBlogInProgress: {}, // { [blogId]: boolean }
    updateBlogError: {},      // { [blogId]: error }
    deleteBlogInProgress: {}, // { [blogId]: boolean }

    deleteBlogError: {},      // { [blogId]: error }
    publishBlogInProgress: {}, // { [blogId]: boolean }
    publishBlogError: {},      // { [blogId]: error }

    retryTranslationsInProgress: {}, // { [blogId]: boolean }
    retryTranslationsStatus: {}, // { [blogId]: 'pending'|'completed'|'failed' }
    retryTranslationsError: {}, // { [blogId]: error }

    // Blog titles state
    blogTitleswithLabels: [],
    blogTitleswithLabelsInProgress: false,
    blogTitleswithLabelsError: null,

    credits: {},
    creditsLoading: false,
    creditsError: null,
    listingRequested: false,
    listingError: null,
    weeklyExceptionQueries: {
        // '2022-12-12': { // Note: id/key is the start of the week in given time zone
        //   fetchExceptionsError: null,
        //   fetchExceptionsInProgress: null,
        // },
    },
    monthlyExceptionQueries: {
        // '2022-12': {
        //   fetchExceptionsError: null,
        //   fetchExceptionsInProgress: null,
        // },
    },
    AIGeneratedImages: null,
    AIGeneratedImagesRequested: false,
    AIGeneratedImagesError: null,

    enhanceFieldInProgress: {},
    enhanceFieldError: {},
    enhancedField: {},

    updateListingInProgress: false,
    updateListingError: null,

    publishListingInProgress: false,
    publishListingError: null,

    allExceptions: [],
    addExceptionError: null,
    addExceptionInProgress: false,
    deleteExceptionError: null,
    deleteExceptionInProgress: false,

    generatedImages: [],
    generateImagesError: null,
    generateImagesInProgress: false,
    activeListingId: null,

    generateBlogsInProgress: false,
    generateBlogsError: null,

    deletedImageIds: [],

    updatedTab: null,

};

// ================ Reducer ================ //

const AIUpdateListingPageReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_CREDITS_REQUEST:
            return { ...state, creditsLoading: true, creditsError: null };
        case GET_CREDITS_SUCCESS:
            return {
                ...state,
                creditsLoading: false,
                credits: {
                    ...payload,
                    maxImageCredits: payload.maxImageCredits ?? state.credits?.maxImageCredits ?? 3,
                },
                creditsError: null,
            };
        case GET_CREDITS_ERROR:
            return { ...state, creditsLoading: false, creditsError: payload };
        case FETCH_LISITNG_REQUESTED:
            return { ...state, listingRequested: true };
        case FETCH_LISTING_SUCCESS:
            return { ...state, listing: payload, listingRequested: false };
        case FETCH_LISTING_ERROR:
            return { ...state, listing: null, listingRequested: false, listingError: payload };
        case FETCH_EXCEPTIONS_REQUEST: {
            const { monthId, weekStartId } = payload.params;
            const newData = {
                fetchExceptionsError: null,
                fetchExceptionsInProgress: true,
            };

            const exceptionQueriesMaybe = monthId
                ? mergeToMonthlyExceptionQueries(
                    state.monthlyExceptionQueries,
                    monthId,
                    newData
                )
                : weekStartId
                    ? mergeToWeeklyExceptionQueries(
                        state.weeklyExceptionQueries,
                        weekStartId,
                        newData
                    )
                    : {};
            return { ...state, ...exceptionQueriesMaybe };
        }
        case FETCH_EXCEPTIONS_SUCCESS: {
            const { exceptions, monthId, weekStartId } = payload;
            const combinedExceptions = state.allExceptions.concat(exceptions);
            const selectId = x => x.id.uuid;
            const allExceptions = uniqueBy(combinedExceptions, selectId).sort(
                sortExceptionsByStartTime
            );
            const newData = { fetchExceptionsInProgress: false };

            const exceptionQueriesMaybe = monthId
                ? mergeToMonthlyExceptionQueries(
                    state.monthlyExceptionQueries,
                    monthId,
                    newData
                )
                : weekStartId
                    ? mergeToWeeklyExceptionQueries(
                        state.weeklyExceptionQueries,
                        weekStartId,
                        newData
                    )
                    : {};
            return { ...state, allExceptions, ...exceptionQueriesMaybe };
        }
        case FETCH_EXCEPTIONS_ERROR: {
            const { monthId, weekStartId, error } = payload;
            const newData = {
                fetchExceptionsInProgress: false,
                fetchExceptionsError: error,
            };

            const exceptionQueriesMaybe = monthId
                ? mergeToMonthlyExceptionQueries(
                    state.monthlyExceptionQueries,
                    monthId,
                    newData
                )
                : weekStartId
                    ? mergeToWeeklyExceptionQueries(
                        state.weeklyExceptionQueries,
                        weekStartId,
                        newData
                    )
                    : {};

            return { ...state, ...exceptionQueriesMaybe };
        }
        case AIGENERATED_IMAGES_REQUESTED:
            return { ...state, AIGeneratedImagesRequested: true };
        case AIGENERATED_IMAGES_SUCCESS:
            return { ...state, AIGeneratedImagesRequested: false, AIGeneratedImages: payload };
        case AIGENERATED_IMAGES_ERROR:
            return { ...state, AIGeneratedImagesRequested: false, AIGeneratedImages: null, AIGeneratedImagesError: payload };

        case ENHANCE_FIELD_REQUEST:
            return { ...state, enhanceFieldInProgress: { ...state.enhanceFieldInProgress, [payload.field]: true } };
        case ENHANCE_FIELD_SUCCESS:
            return {
                ...state,
                enhanceFieldInProgress: { ...state.enhanceFieldInProgress, [payload.field]: false },
                enhancedField: { ...state.enhancedField, [payload.field]: payload.data }
            };
        case ENHANCE_FIELD_ERROR:
            return {
                ...state,
                enhanceFieldInProgress: { ...state.enhanceFieldInProgress, [payload.field]: false },
                enhanceFieldError: { ...state.enhanceFieldError, [payload.field]: payload.error }
            };

        case UPDATE_LISTING_REQUEST:
            return { ...state, updateListingInProgress: true };
        case UPDATE_LISTING_SUCCESS:
            return { ...state, updateListingInProgress: false, updateListingError: null };
        case UPDATE_LISTING_ERROR:
            return { ...state, updateListingInProgress: false, updateListingError: payload };
        case PUBLISH_LISTING_REQUEST:
            return { ...state, publishListingInProgress: true };
        case PUBLISH_LISTING_SUCCESS:
            return { ...state, publishListingInProgress: false, publishListingError: null };
        case PUBLISH_LISTING_ERROR:
            return { ...state, publishListingInProgress: false, publishListingError: payload };

        case ADD_AVAILABILITY_EXCEPTION_REQUEST:
            return {
                ...state,
                addExceptionError: null,
                addExceptionInProgress: true,
            };
        case ADD_AVAILABILITY_EXCEPTION_SUCCESS: {
            const exception = payload;
            const combinedExceptions = state.allExceptions.concat(exception);
            const allExceptions = combinedExceptions.sort(sortExceptionsByStartTime);
            return {
                ...state,
                allExceptions,
                addExceptionInProgress: false,
            };
        }
        case ADD_AVAILABILITY_EXCEPTION_ERROR:
            return {
                ...state,
                addExceptionError: payload.error,
                addExceptionInProgress: false,
            };

        case DELETE_AVAILABILITY_EXCEPTION_REQUEST:
            return {
                ...state,
                deleteExceptionError: null,
                deleteExceptionInProgress: true,
            };
        case DELETE_AVAILABILITY_EXCEPTION_SUCCESS: {
            const exception = payload;
            const id = exception.id.uuid;
            const allExceptions = state.allExceptions.filter(e => e.id.uuid !== id);
            return {
                ...state,
                allExceptions,
                deleteExceptionInProgress: false,
            };
        }
        case DELETE_AVAILABILITY_EXCEPTION_ERROR:
            return {
                ...state,
                deleteExceptionError: payload.error,
                deleteExceptionInProgress: false,
            };

        case FETCH_EXTRA_EXCEPTIONS_SUCCESS: {
            const combinedExceptions = state.allExceptions.concat(payload.exceptions);
            const selectId = x => x.id.uuid;
            const allExceptions = uniqueBy(combinedExceptions, selectId).sort(
                sortExceptionsByStartTime
            );
            // TODO: currently we don't handle thrown errors from these paginated calls
            return { ...state, allExceptions };
        }

        case GENERATE_AI_IMAGES_REQUEST:
            return {
                ...state,
                generateImagesInProgress: true,
                generateImagesError: null,
                activeListingId: action.payload,
            };
        case GENERATE_AI_IMAGES_SUCCESS: {
            const { images, listingId } = action.payload;
            if (listingId && listingId !== state.activeListingId) {
                return state;
            }
            return {
                ...state,
                generateImagesInProgress: false,
                generateImagesError: null,
                generatedImages: images,
            };
        }
        case GENERATE_AI_IMAGES_ERROR: {
            const { error, listingId } = action.payload;
            if (listingId && listingId !== state.activeListingId) {
                return state;
            }
            return {
                ...state,
                generateImagesInProgress: false,
                generateImagesError: error,
            };
        }
        case RESET_GENERATED_IMAGES:
            return {
                ...state,
                generatedImages: [],
                generateImagesInProgress: false,
                generateImagesError: null,
                activeListingId: null,
            };

        case GENERATE_BLOG_TITLES_REQUEST:
            return { ...state, blogTitleswithLabelsInProgress: true, blogTitleswithLabelsError: null };
        case GENERATE_BLOG_TITLES_SUCCESS:
            return { ...state, blogTitleswithLabelsInProgress: false, blogTitleswithLabels: action.payload };
        case GENERATE_BLOG_TITLES_ERROR:
            return { ...state, blogTitleswithLabelsInProgress: false, blogTitleswithLabelsError: action.error };

        case GENERATE_BLOGS_REQUEST:
            return { ...state, generateBlogsInProgress: true, generateBlogsError: null };
        case GENERATE_BLOGS_SUCCESS:
            return { ...state, generateBlogsInProgress: false, generateBlogsError: null };
        case GENERATE_BLOGS_ERROR:
            return { ...state, generateBlogsInProgress: false, generateBlogsError: action.error };

        // BLOGS REDUCER LOGIC
        case FETCH_BLOGS_REQUEST:
            return { ...state, fetchBlogsInProgress: true, fetchBlogsError: null };
        case FETCH_BLOGS_SUCCESS:
            return { ...state, fetchBlogsInProgress: false, fetchBlogsError: null, blogs: payload.blogs, analytics: payload.analytics };
        case FETCH_BLOGS_ERROR:
            return { ...state, fetchBlogsInProgress: false, fetchBlogsError: payload.error };

        case UPDATE_BLOG_REQUEST:
            return {
                ...state,
                updateBlogInProgress: { ...state.updateBlogInProgress, [payload.id]: true },
                updateBlogError: { ...state.updateBlogError, [payload.id]: null },
            };
        case UPDATE_BLOG_SUCCESS:
            return {
                ...state,
                updateBlogInProgress: { ...state.updateBlogInProgress, [payload.blog._id]: false },
                updateBlogError: { ...state.updateBlogError, [payload.blog._id]: null },
                blogs: state.blogs.map(b => b._id === payload.blog._id ? payload.blog : b),
            };
        case UPDATE_BLOG_ERROR:
            return {
                ...state,
                updateBlogInProgress: { ...state.updateBlogInProgress, [payload.id]: false },
                updateBlogError: { ...state.updateBlogError, [payload.id]: payload.error },
            };

        case DELETE_BLOG_REQUEST:
            return {
                ...state,
                deleteBlogInProgress: { ...state.deleteBlogInProgress, [payload.id]: true },
                deleteBlogError: { ...state.deleteBlogError, [payload.id]: null },
            };
        case DELETE_BLOG_SUCCESS:
            return {
                ...state,
                deleteBlogInProgress: { ...state.deleteBlogInProgress, [payload.id]: false },
                deleteBlogError: { ...state.deleteBlogError, [payload.id]: null },
                blogs: state.blogs.filter(b => b._id !== payload.id),
            };
        case DELETE_BLOG_ERROR:
            return {
                ...state,
                deleteBlogInProgress: { ...state.deleteBlogInProgress, [payload.id]: false },
                deleteBlogError: { ...state.deleteBlogError, [payload.id]: payload.error },
            };

        case PUBLISH_BLOG_REQUEST:
            return {
                ...state,
                publishBlogInProgress: { ...state.publishBlogInProgress, [payload.id]: true },
                publishBlogError: { ...state.publishBlogError, [payload.id]: null },
            };
        case PUBLISH_BLOG_SUCCESS:
            return {
                ...state,
                publishBlogInProgress: { ...state.publishBlogInProgress, [payload.blog._id]: false },
                publishBlogError: { ...state.publishBlogError, [payload.blog._id]: null },
                blogs: state.blogs.map(b => b._id === payload.blog._id ? payload.blog : b),
            };
        case PUBLISH_BLOG_ERROR:
            return {
                ...state,
                publishBlogInProgress: { ...state.publishBlogInProgress, [payload.id]: false },
                publishBlogError: { ...state.publishBlogError, [payload.id]: payload.error },
            };

        case RETRY_BLOG_TRANSLATIONS_REQUEST:
            return {
                ...state,
                retryTranslationsInProgress: { ...state.retryTranslationsInProgress, [payload.id]: true },
                retryTranslationsStatus: { ...state.retryTranslationsStatus, [payload.id]: 'in_progress' },
                retryTranslationsError: { ...state.retryTranslationsError, [payload.id]: null },
            };
        case RETRY_BLOG_TRANSLATIONS_SUCCESS:
            return {
                ...state,
                retryTranslationsInProgress: { ...state.retryTranslationsInProgress, [payload.id]: false },
                retryTranslationsStatus: { ...state.retryTranslationsStatus, [payload.id]: payload.status || 'completed' },
                retryTranslationsError: { ...state.retryTranslationsError, [payload.id]: null },
                blogs: state.blogs.map(b => b._id === payload.id ? payload.blog : b),
            };
        case RETRY_BLOG_TRANSLATIONS_ERROR:
            return {
                ...state,
                retryTranslationsInProgress: { ...state.retryTranslationsInProgress, [payload.id]: false },
                retryTranslationsStatus: { ...state.retryTranslationsStatus, [payload.id]: 'failed' },
                retryTranslationsError: { ...state.retryTranslationsError, [payload.id]: payload.error },
            };

        case SET_DELETED_IMAGE_IDS:
            return {
                ...state,
                deletedImageIds: payload.removed
                    ? [...state.deletedImageIds, { sharetribeImgId: payload.sharetribeImgId, cloudinaryPublicId: payload.cloudinaryPublicId }]
                    : state.deletedImageIds.filter(id => id.sharetribeImgId !== payload.sharetribeImgId && id.cloudinaryPublicId !== payload.cloudinaryPublicId),
            };

        case RESET_DELETED_IMAGE_IDS:
            return {
                ...state,
                deletedImageIds: [],
            };

        case MARK_TAB_UPDATED:
            return { ...state, updatedTab: payload };
        case CLEAR_UPDATED_TAB:
            return { ...state, updatedTab: null, updateListingError: null };

        case DISMISS_MIGRATION_BANNER_REQUEST:
            return state;
        case DISMISS_MIGRATION_BANNER_SUCCESS:
            return state;
        case DISMISS_MIGRATION_BANNER_ERROR:
            return state;

        default:
            return state;
    }
};

export default AIUpdateListingPageReducer;


// ================ Action creators ================ //

const requestAction = actionType => params => ({
    type: actionType,
    payload: { params },
});

const successAction = actionType => result => ({
    type: actionType,
    payload: result.data,
});

const errorAction = actionType => payload => ({
    type: actionType,
    payload,
    error: true,
});

export const AIgeneratedImagesRequest = () => ({
    type: AIGENERATED_IMAGES_REQUESTED
});

export const AIgeneratedImagesSuccess = (payload) => ({
    type: AIGENERATED_IMAGES_SUCCESS,
    payload: payload
});

export const AIgeneratedImagesError = (payload) => ({
    type: AIGENERATED_IMAGES_ERROR,
    payload: payload
});

export const showListingsRequest = () => ({
    type: FETCH_LISITNG_REQUESTED
});

export const showListingsSuccess = (payload) => ({
    type: FETCH_LISTING_SUCCESS,
    payload: payload
});

export const showListingsError = (payload) => ({
    type: FETCH_LISTING_ERROR,
    payload: payload
});

// SDK method: availabilityExceptions.query
export const fetchAvailabilityExceptionsRequest = requestAction(
    FETCH_EXCEPTIONS_REQUEST
);
export const fetchAvailabilityExceptionsSuccess = successAction(
    FETCH_EXCEPTIONS_SUCCESS
);
export const fetchAvailabilityExceptionsError = errorAction(
    FETCH_EXCEPTIONS_ERROR
);

export const updateListingRequest = _ => ({
    type: UPDATE_LISTING_REQUEST
});

export const updateListingSuccess = () => dispatch => {
    dispatch({ type: UPDATE_LISTING_SUCCESS });
};

export const updateListingError = error => ({
    type: UPDATE_LISTING_ERROR,
    payload: error
});

export const publishListingRequest = () => ({
    type: PUBLISH_LISTING_REQUEST
});

export const publishListingSuccess = () => ({
    type: PUBLISH_LISTING_SUCCESS
});

export const publishListingError = error => ({
    type: PUBLISH_LISTING_ERROR,
    payload: error
});


export const getCreditsRequest = () => ({ type: GET_CREDITS_REQUEST });
export const getCreditsSuccess = payload => ({ type: GET_CREDITS_SUCCESS, payload });
export const getCreditsError = error => ({ type: GET_CREDITS_ERROR, payload: error });

export const enhanceFieldRequest = field => ({ type: ENHANCE_FIELD_REQUEST, payload: { field } });
export const enhanceFieldSuccess = (field, enhancedContent) => ({ type: ENHANCE_FIELD_SUCCESS, payload: { field, data: enhancedContent[field] } });
export const enhanceFieldError = (field, error) => ({ type: ENHANCE_FIELD_ERROR, payload: { field, error } });

export const addAvailabilityExceptionRequest = () => ({ type: ADD_AVAILABILITY_EXCEPTION_REQUEST });
export const addAvailabilityExceptionSuccess = (payload) => ({ type: ADD_AVAILABILITY_EXCEPTION_SUCCESS, payload });
export const addAvailabilityExceptionError = (payload) => ({ type: ADD_AVAILABILITY_EXCEPTION_ERROR, payload });

export const deleteAvailabilityExceptionRequest = () => ({ type: DELETE_AVAILABILITY_EXCEPTION_REQUEST });
export const deleteAvailabilityExceptionSuccess = (payload) => ({ type: DELETE_AVAILABILITY_EXCEPTION_SUCCESS, payload });
export const deleteAvailabilityExceptionError = (payload) => ({ type: DELETE_AVAILABILITY_EXCEPTION_ERROR, payload });

// Add extra data from additional pages
export const fetchExtraAvailabilityExceptionsSuccess = successAction(
    FETCH_EXTRA_EXCEPTIONS_SUCCESS
);

export const generateAIImagesRequest = (listingId) => ({ type: GENERATE_AI_IMAGES_REQUEST, payload: listingId });
export const generateAIImagesSuccess = (images, listingId) => ({ type: GENERATE_AI_IMAGES_SUCCESS, payload: { images, listingId } });
export const generateAIImagesError = (error, listingId) => ({ type: GENERATE_AI_IMAGES_ERROR, payload: { error: storableError(error), listingId } });
export const resetGeneratedImages = () => ({ type: RESET_GENERATED_IMAGES });

export const generateBlogTitlesRequest = () => ({ type: GENERATE_BLOG_TITLES_REQUEST });
export const generateBlogTitlesSuccess = titles => ({ type: GENERATE_BLOG_TITLES_SUCCESS, payload: titles });
export const generateBlogTitlesError = error => ({ type: GENERATE_BLOG_TITLES_ERROR, error });

export const generateBlogsRequest = () => ({ type: GENERATE_BLOGS_REQUEST });
export const generateBlogsSuccess = blogs => ({ type: GENERATE_BLOGS_SUCCESS, payload: blogs });
export const generateBlogsError = error => ({ type: GENERATE_BLOGS_ERROR, error });

const fetchBlogsRequest = () => ({ type: FETCH_BLOGS_REQUEST });
const fetchBlogsSuccess = ({ blogs, analytics }) => ({ type: FETCH_BLOGS_SUCCESS, payload: { blogs, analytics } });
const fetchBlogsError = error => ({ type: FETCH_BLOGS_ERROR, payload: { error } });

const updateBlogRequest = id => ({ type: UPDATE_BLOG_REQUEST, payload: { id } });
const updateBlogSuccess = blog => ({ type: UPDATE_BLOG_SUCCESS, payload: { blog } });
const updateBlogError = (id, error) => ({ type: UPDATE_BLOG_ERROR, payload: { id, error } });

const deleteBlogRequest = id => ({ type: DELETE_BLOG_REQUEST, payload: { id } });
const deleteBlogSuccess = id => ({ type: DELETE_BLOG_SUCCESS, payload: { id } });
const deleteBlogError = (id, error) => ({ type: DELETE_BLOG_ERROR, payload: { id, error } });

const publishBlogRequest = id => ({ type: PUBLISH_BLOG_REQUEST, payload: { id } });
const publishBlogSuccess = blog => ({ type: PUBLISH_BLOG_SUCCESS, payload: { blog } });
const publishBlogError = (id, error) => ({ type: PUBLISH_BLOG_ERROR, payload: { id, error } });

const retryBlogTranslationsRequest = id => ({
    type: RETRY_BLOG_TRANSLATIONS_REQUEST,
    payload: { id },
});
const retryBlogTranslationsSuccess = (id, blog, status) => ({
    type: RETRY_BLOG_TRANSLATIONS_SUCCESS,
    payload: { id, blog, status },
});
const retryBlogTranslationsError = (id, error) => ({
    type: RETRY_BLOG_TRANSLATIONS_ERROR,
    payload: { id, error },
});

export const setDeletedImageIds = ({ sharetribeImgId, cloudinaryPublicId, removed }) => ({ type: SET_DELETED_IMAGE_IDS, payload: { sharetribeImgId, cloudinaryPublicId, removed } });
export const resetDeletedImageIds = () => ({ type: RESET_DELETED_IMAGE_IDS });

export const markTabUpdated = tab => ({
    type: MARK_TAB_UPDATED,
    payload: tab,
});

export const clearUpdatedTab = () => ({
    type: CLEAR_UPDATED_TAB,
});

// ================ Thunks ================ //
export const requestGetCredits = (listingToken) => async (dispatch) => {
    try {
        dispatch(getCreditsRequest());
        const credits = await getCredits(listingToken);
        dispatch(getCreditsSuccess(credits.remainingCredits));
    } catch (error) {
        dispatch(getCreditsError(error));
    }
};

export const requestAIToGenerateImages = params => (dispatch, getState, sdk) => {

    const { listingId, AIGeneratedImages = [], ...rest } = params;

    try {
        dispatch(AIgeneratedImagesRequest());

        return generateAIImages(rest).then(async response => {
            const { images = [] } = response;

            let imageResults = [];

            if (images && images.length) {
                imageResults = await Promise.all(images.map(async (img) => {
                    const file = await urlToFile(img.imageUrl, `listing-img-${uuid4()}`, 'image/jpeg');
                    const imgRes = await sdk.images.upload({ image: file });
                    return {
                        id: imgRes.data.data.id.uuid,
                        imageUrl: img.imageUrl,
                        publicId: img.publicId,
                        height: img.height,
                        width: img.width,
                        metadata: img.metadata
                    };
                }));
            }

            // need to update the listing, and the data from the images
            dispatch(updateOwnListing({
                listingId: listingId,
                publicData: {
                    aIGeneratedImagesData: [...AIGeneratedImages, ...imageResults]
                }
            }));

            dispatch(AIgeneratedImagesSuccess(imageResults));

            return imageResults;
        });
    } catch (error) {
        return dispatch(AIgeneratedImagesError(error));
    }
};

export const requestAddAvailabilityException = params => (
    dispatch,
    getState,
    sdk
) => {
    dispatch(addAvailabilityExceptionRequest(params));

    return sdk.availabilityExceptions
        .create(params, { expand: true })
        .then(response => {
            const availabilityException = response.data.data;
            return dispatch(
                addAvailabilityExceptionSuccess({ data: availabilityException })
            );
        })
        .catch(e => {
            dispatch(addAvailabilityExceptionError({ error: storableError(e) }));
            throw e;
        });
};

export const requestDeleteAvailabilityException = params => (
    dispatch,
    getState,
    sdk
) => {
    dispatch(deleteAvailabilityExceptionRequest(params));

    return sdk.availabilityExceptions
        .delete(params, { expand: true })
        .then(response => {
            const availabilityException = response.data.data;
            return dispatch(
                deleteAvailabilityExceptionSuccess(availabilityException)
            );
        })
        .catch(e => {
            dispatch(deleteAvailabilityExceptionError({ error: storableError(e) }));
            throw e;
        });
};

export const requestFetchAvailabilityExceptions = params => (
    dispatch,
    getState,
    sdk
) => {
    const { listingId, start, end, timeZone, page, isWeekly } = params;
    const fetchParams = { listingId, start, end };
    const timeUnitIdProp = isWeekly
        ? { weekStartId: stringifyDateToISO8601(start) }
        : { monthId: monthIdString(start, timeZone) };
    dispatch(fetchAvailabilityExceptionsRequest(timeUnitIdProp));

    return sdk.availabilityExceptions
        .query(fetchParams)
        .then(response => {
            const availabilityExceptions = denormalisedResponseEntities(response);

            // Fetch potential extra exceptions pagination pages per month.
            // In theory, there could be several pagination pages worth of exceptions,
            // if range is month and unit is 'hour': 31 days * 24 hour = 744 slots for exceptions.
            const totalPages = response.data.meta.totalPages;
            if (totalPages > 1 && !page) {
                const extraPages = getArrayOfNItems(totalPages);

                // It's unlikely that this code is reached with default units.
                // Note:
                //  - Firing multiple API calls might hit API rate limit
                //    (This is very unlikely with this query and 'hour' unit.)
                //  - TODO: this doesn't take care of failures of those extra calls
                Promise.all(
                    extraPages.map(page => {
                        return sdk.availabilityExceptions.query({ ...fetchParams, page });
                    })
                ).then(responses => {
                    const denormalizedFlatResults = (all, r) =>
                        all.concat(denormalisedResponseEntities(r));
                    const exceptions = responses.reduce(denormalizedFlatResults, []);
                    dispatch(
                        fetchExtraAvailabilityExceptionsSuccess({
                            data: { ...timeUnitIdProp, exceptions },
                        })
                    );
                });
            }

            return dispatch(
                fetchAvailabilityExceptionsSuccess({
                    data: { ...timeUnitIdProp, exceptions: availabilityExceptions },
                })
            );
        })
        .catch(e => {
            return dispatch(
                fetchAvailabilityExceptionsError({
                    ...timeUnitIdProp,
                    error: storableError(e),
                })
            );
        });
};

// Helper function for loadData call.
const fetchLoadDataExceptions = (dispatch, listing, search, firstDayOfWeek = 1) => {
    const hasWindow = typeof window !== 'undefined';
    // Listing could be ownListing entity too, so we just check if attributes key exists
    const hasTimeZone = listing?.attributes?.availabilityPlan?.timezone;

    // Fetch time-zones on client side only.
    // Note: listing needs to have time zone set!
    if (hasWindow && listing.id && hasTimeZone) {
        const listingId = listing.id;
        // If the listing doesn't have availabilityPlan yet
        // use the defaul timezone
        const timezone =
            listing.attributes.availabilityPlan?.timezone ||
            getDefaultTimeZoneOnBrowser();
        const todayInListingsTZ = getStartOf(new Date(), 'day', timezone);

        const locationSearch = parse(search);
        const selectedDate = locationSearch?.d
            ? parseDateFromISO8601(locationSearch.d, timezone)
            : todayInListingsTZ;
        const startOfWeek = getStartOfWeek(selectedDate, timezone, firstDayOfWeek);
        const prevWeek = getStartOf(startOfWeek, 'day', timezone, -7, 'days');
        const nextWeek = getStartOf(startOfWeek, 'day', timezone, 7, 'days');
        const nextAfterNextWeek = getStartOf(nextWeek, 'day', timezone, 7, 'days');

        const nextMonth = getStartOf(
            todayInListingsTZ,
            'month',
            timezone,
            1,
            'months'
        );
        const nextAfterNextMonth = getStartOf(
            nextMonth,
            'month',
            timezone,
            1,
            'months'
        );

        const sharedData = { listingId, timeZone: timezone };

        // Fetch data for selected week and nearest weeks for WeeklyCalendar
        // Plus current month and month after that for EditListingAvailabilityForm
        //
        // NOTE: This is making 5 different Thunk calls, which update store 2 times each
        //       It would make sense to make on thunk function that fires 5 sdk calls/promises,
        //       but for the time being, it's clearer to push all the calls through
        //       requestFetchAvailabilityExceptions
        return Promise.all([
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    isWeekly: true,
                    start: prevWeek,
                    end: startOfWeek,
                })
            ),
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    isWeekly: true,
                    start: startOfWeek,
                    end: nextWeek,
                })
            ),
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    isWeekly: true,
                    start: nextWeek,
                    end: nextAfterNextWeek,
                })
            ),
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    start: todayInListingsTZ,
                    end: nextMonth,
                })
            ),
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    start: nextMonth,
                    end: nextAfterNextMonth,
                })
            ),
        ]);
    }

    // By default return an empty array
    return Promise.all([]);
};

// fetch the listing, with it's data as it is own listing.
export const requestShowListing = (actionPayload, config) => (dispatch, getState, sdk) => {
    const imageVariantInfo = getImageVariantInfo(config.layout.listingImage);
    const queryParams = {
        include: ['author', 'images', 'currentStock'],
        'fields.image': imageVariantInfo.fieldsImage,
        ...imageVariantInfo.imageVariants,
    };

    dispatch(showListingsRequest());
    return sdk.ownListings
        .show({ ...actionPayload, ...queryParams })
        .then(response => {
            // EditListingPage fetches new listing data, which also needs to be added to global data
            dispatch(addMarketplaceEntities(response));
            // In case of success, we'll clear state.EditListingPage (user will be redirected away)
            const denormalizedResponse = denormalisedResponseEntities(response);
            dispatch(showListingsSuccess(denormalizedResponse[0]));
            return response;
        })
        .catch(e => dispatch(showListingsError(storableError(e))));
};



export const requestEnhanceField = (enhanceFieldParams) => async (dispatch, getState, sdk) => {
    try {
        dispatch(enhanceFieldRequest(enhanceFieldParams.fieldName));
        const { data } = await enhanceField(enhanceFieldParams);
        const remainingCredits = data.remainingCredits;

        dispatch(enhanceFieldSuccess(data.fieldName, data.enhancedContent));
        dispatch(getCreditsSuccess(remainingCredits));

        return {
            fieldName: data.fieldName,
            enhancedContent: data.enhancedContent
        };
    } catch (error) {
        dispatch(enhanceFieldError(enhanceFieldParams.fieldName, error));
        throw error;
    }
};

const processImages = async (images, sdk) => {
    // Upload images to sharetribe and cloudinary
    // Only fresh images will be uploaded to cloudinary
    // May include fresh images and generated images
    // Generated images already exist in Cloudinary — we fetch them via urlToFile
    // to create a File for Sharetribe upload while preserving their Cloudinary URL.
    // The first image is cover photo, you need to keep that at first in the listing images and sharetribe

    // Store results with their original index
    let firstImagePublicId = null;
    let firstImageSharetribeId = null;
    const uploadResults = [];
    const uploadErrors = [];

    if (images && images.length > 0) {
        const allUploadPromises = images.map((image, idx) => {
            // File image
            if (image instanceof File) {
                return (async () => {
                    try {
                        const uploadRes = await sdk.images.upload({ image });
                        const id = uploadRes.data.data.id.uuid;
                        // Upload to cloudinary
                        const result = await UploadImage({ file: image, id });
                        if (!result || !result.secure_url) {
                            throw new Error('Cloudinary upload failed');
                        }
                        uploadResults[idx] = {
                            public_id: result.public_id,
                            secure_url: result.secure_url,
                            height: result.height,
                            width: result.width,
                            sharetribeImgId: id,
                        };
                        if (idx === 0) {
                            firstImagePublicId = result.public_id;
                            firstImageSharetribeId = id;
                        }
                        return { success: true, idx, id };
                    } catch (error) {
                        const fileName = image.name || `Image ${idx + 1}`;
                        uploadErrors.push({
                            index: idx + 1,
                            fileName,
                            error: error.message || 'Upload failed'
                        });
                        console.error(`Failed to upload ${fileName}:`, error);
                        return { success: false, idx, error: error.message };
                    }
                })();
            }
            // Cloudinary image
            else if (image.newGenerated && image.secure_url) {
                return (async () => {
                    try {
                        const file = await urlToFile(image.secure_url, image.public_id, image.mimeType || 'image/jpeg');
                        const uploadRes = await sdk.images.upload({ image: file });
                        const id = uploadRes.data.data.id.uuid;
                        uploadResults[idx] = {
                            public_id: image.public_id,
                            secure_url: image.secure_url,
                            height: image.height,
                            width: image.width,
                            sharetribeImgId: id,
                        };
                        if (idx === 0) {
                            firstImagePublicId = image.public_id;
                            firstImageSharetribeId = id;
                        }
                        return { success: true, idx, id };
                    } catch (error) {
                        const fileName = `New Generated Image ${idx + 1}`;
                        uploadErrors.push({
                            index: idx + 1,
                            fileName,
                            error: error.message || 'Upload failed'
                        });
                        console.error(`Failed to upload ${fileName}:`, error);
                        return { success: false, idx, error: error.message };
                    }
                })();
            }
            // Fallback (existing images - should not need upload)
            else {
                if (idx === 0) {
                    firstImagePublicId = image.public_id;
                    firstImageSharetribeId = image.sharetribeImgId;
                }
                uploadResults[idx] = null;
                return Promise.resolve({ success: true, idx, isExisting: true });
            }
        });

        // Use allSettled to handle individual failures without blocking entire operation
        const results = await Promise.allSettled(allUploadPromises);

        // Extract successful uploads
        const validResults = uploadResults.filter(Boolean);
        const validSharetribeImageIds = results
            .filter(r => r.status === 'fulfilled' && r.value?.success && r.value?.id)
            .map(r => r.value.id);


        return {
            listingImages: validResults,
            uploadResultsByIndex: uploadResults,
            sharetribeImageIds: validSharetribeImageIds,
            firstImagePublicId,
            firstImageSharetribeId,
            uploadErrors,
            hasFailures: uploadErrors.length > 0,
            successCount: validResults.length,
            totalCount: images.length
        };
    }
    return {
        listingImages: [],
        sharetribeImageIds: [],
        uploadErrors: [],
        hasFailures: false,
        successCount: 0,
        totalCount: 0
    };
};


export function requestUpdateListing(tab, data, config, language) {
    return async (dispatch, getState, sdk) => {
        dispatch(updateListingRequest(data));

        try {
            // `images` is intentionally NOT defaulted to [] here.
            // undefined means the submitting tab did not touch photos at all (Details, Pricing,
            // Location, Availability). An actual array (even empty) means the Photos tab submitted
            // and the user's intent should be respected.
            const { id, images, publicData, availabilityExceptions = [], ...rest } = data;
            const applicationState = getState();

            // Whether this submission came from the Photos tab.
            const isPhotoTabSubmission = images !== undefined;

            // Check existing images in the listing (needed in both paths)
            const currentListing = applicationState.AIUpdateListingPage.listing;
            const currentListingPublicData = currentListing?.attributes?.publicData;
            const existingImages = currentListingPublicData?.listingImages || [];

            // These are only meaningful during a Photos-tab submission.
            const deletedImageIds = applicationState.AIUpdateListingPage.deletedImageIds;
            const deletedCloudinaryPublicIds = deletedImageIds.map(id => id.cloudinaryPublicId);
            const deletedSharetribeImageIds = deletedImageIds.map(id => id.sharetribeImgId);

            // Legacy listings (created before we started storing `sharetribeImgId` in
            // publicData.listingImages) are missing that field on their existing images.
            // The Sharetribe `images` relationship is the source of truth for identity/order,
            // and was always written in lockstep with publicData.listingImages, so when the
            // counts still agree we can recover the id positionally. If they don't agree,
            // something else is wrong and we should not guess.
            const currentListingImageIds = (currentListing?.images || [])
                .map(img => img?.id?.uuid)
                .filter(Boolean);
            const canRecoverImageIdsPositionally =
                existingImages.length > 0 && existingImages.length === currentListingImageIds.length;
            const unrecoverableImages = [];

            let orderedListingImages = [];
            let orderedSharetribeIds = [];
            let partialFailureWarning = null;

            if (isPhotoTabSubmission) {
                // Process images with detailed error tracking
                const imageProcessResult = await processImages(images, sdk);
                const {
                    listingImages = [],
                    uploadResultsByIndex = [],
                    uploadErrors = [],
                    hasFailures = false,
                    successCount = 0,
                    totalCount = 0
                } = imageProcessResult;

                // Filter out deleted images from the existing set
                const remainingExistingImages = existingImages.filter(
                    img => !deletedCloudinaryPublicIds.includes(img.public_id)
                );

                const hasExistingImages = remainingExistingImages.length > 0;
                const hasNewSuccessfulImages = listingImages.length > 0;

                // All uploads failed AND no pre-existing images survive — hard error
                if (images?.length > 0 && !hasExistingImages && !hasNewSuccessfulImages) {
                    let errorMessage = `All ${totalCount} image upload${totalCount > 1 ? 's' : ''} failed. `;
                    if (uploadErrors.length > 0) {
                        errorMessage += uploadErrors.map(e => `${e.fileName}: ${e.error}`).join('; ') + '. ';
                    }
                    errorMessage += 'Please try again or ensure images are in an accepted format (PNG, JPG, JPEG, GIF).';
                    throw new Error(errorMessage);
                }

                // Soft warning when some uploads failed but we still have images
                if (hasFailures && (hasExistingImages || hasNewSuccessfulImages)) {
                    partialFailureWarning = `${uploadErrors.length} of ${totalCount} image${totalCount > 1 ? 's' : ''} failed to upload (${uploadErrors.map(e => `${e.fileName}: ${e.error}`).join('; ')}). The listing was updated with ${successCount} successful image${successCount !== 1 ? 's' : ''}.`;
                    console.warn('Partial image upload failure:', partialFailureWarning);
                }

                // Rebuild image arrays in the exact order the user set via drag-and-drop.
                for (let i = 0; i < images?.length; i++) {
                    const image = images[i];

                    // Skip images the user explicitly deleted
                    if (image.public_id && deletedCloudinaryPublicIds.includes(image.public_id)) continue;
                    if (image.sharetribeImgId && deletedSharetribeImageIds.includes(image.sharetribeImgId)) continue;

                    const uploadedResult = uploadResultsByIndex[i];

                    if (uploadedResult) {
                        orderedListingImages.push(uploadedResult);
                        orderedSharetribeIds.push(uploadedResult.sharetribeImgId);
                    } else if (image.sharetribeImgId) {
                        orderedListingImages.push(image);
                        orderedSharetribeIds.push(image.sharetribeImgId);
                    } else {
                        // Existing image with no sharetribeImgId — almost always a legacy
                        // listing predating that field. Recover it positionally from the
                        // Sharetribe images relationship when the counts still line up;
                        // otherwise skip it (without blocking the rest of the update) and
                        // tell the user why in plain language.
                        const originalIndex = canRecoverImageIdsPositionally
                            ? existingImages.findIndex(img => img.public_id && img.public_id === image.public_id)
                            : -1;
                        const recoveredId = originalIndex > -1 ? currentListingImageIds[originalIndex] : null;

                        if (recoveredId) {
                            orderedListingImages.push({ ...image, sharetribeImgId: recoveredId });
                            orderedSharetribeIds.push(recoveredId);
                        } else {
                            unrecoverableImages.push(image);
                        }
                    }
                }

                if (unrecoverableImages.length > 0) {
                    const imageNoun = unrecoverableImages.length === 1 ? 'photo' : 'photos';
                    const imageWarning = `We couldn't carry over ${unrecoverableImages.length} older ${imageNoun} on this listing — ${unrecoverableImages.length === 1 ? 'it is' : 'they are'} missing some data from before we added AI photo support. The rest of your changes were saved; please re-upload ${unrecoverableImages.length === 1 ? 'it' : 'them'} if you'd like to keep ${unrecoverableImages.length === 1 ? 'it' : 'them'} in the listing.`;
                    partialFailureWarning = partialFailureWarning
                        ? `${partialFailureWarning} ${imageWarning}`
                        : imageWarning;
                    console.warn('Unrecoverable legacy image(s) dropped from update:', unrecoverableImages.map(img => img.public_id));
                }
            }


            // Instruction video maybe
            if (publicData?.instructions?.video instanceof File) {
                const videoFile = publicData.instructions.video;
                const uploadRes = await UploadVideo({
                    file: videoFile,
                    id: uuid4(),
                });

                const storeName = applicationState.user.currentUser?.attributes?.profile?.publicData?.storeName || '';
                const videoSeoTags = buildListingVideoSeoTags(currentListing, storeName);

                publicData.instructions.video = {
                    public_id:    uploadRes.public_id,
                    asset_id:     uploadRes.asset_id,
                    width:        uploadRes.width,
                    height:       uploadRes.height,
                    playback_url: uploadRes.playback_url,
                    seoTags:      videoSeoTags,
                };

                updateCloudinaryContext({
                    publicId:     uploadRes.public_id,
                    context:      videoSeoTags,
                    resourceType: 'video',
                }).catch(err => console.error('Cloudinary video context update failed:', err));

                // Clear videoUrl when video file is uploaded (component already handles this, but ensure it's cleared here too)
                if (publicData.instructions.videoUrl) {
                    publicData.instructions.videoUrl = null;
                }
            }
            // videoUrl is preserved automatically in publicData.instructions if it exists

            // Only a real Cloudinary upload may be persisted: anything else (a File,
            // `{}`, a result without playback_url) becomes null so the listing page
            // never sees an empty-but-truthy video (which used to 500 during SSR).
            if (
                publicData?.instructions &&
                typeof publicData.instructions === 'object' &&
                publicData.instructions.video != null &&
                !isUploadedInstructionVideo(publicData.instructions.video)
            ) {
                publicData.instructions = { ...publicData.instructions, video: null };
            }

            const storeName = applicationState.user.currentUser?.attributes?.profile?.publicData?.storeName || '';

            // Build publicData. When images were not submitted by this tab, omit listingImages
            // entirely so the existing value on the server is preserved.
            const updatedPublicData = isPhotoTabSubmission
                ? {
                    ...publicData,
                    listingImages: orderedListingImages.map((img, idx) => {
                        if (img.seoTags) return img;
                        return { ...img, seoTags: buildListingImageSeoTags(currentListing, idx, storeName) };
                    }),
                    updatedAt: new Date().toISOString(),
                }
                : {
                    ...publicData,
                    updatedAt: new Date().toISOString(),
                };

            // Only include `images` (Sharetribe image IDs) in the update payload when this is a
            // Photos-tab submission. Omitting the field tells Sharetribe to leave existing images
            // untouched, preventing accidental deletion from other tabs.
            const ownListingUpdateValues = isPhotoTabSubmission
                ? { id, images: orderedSharetribeIds, publicData: updatedPublicData, ...rest }
                : { id, publicData: updatedPublicData, ...rest };

            const imageVariantInfo = getImageVariantInfo(config.layout.listingImage);
            const queryParams = {
                expand: true,
                include: ['author', 'images', 'currentStock'],
                'fields.image': imageVariantInfo.fieldsImage,
                ...imageVariantInfo.imageVariants,
            };

            const { currentUser } = applicationState.user;
            const { email } = currentUser.attributes;

            const {
                firstName,
                lastName,
                displayName,
                publicData: userPublicData,
            } = currentUser.attributes.profile;

            const existingTimeZone =
                applicationState.marketplaceData.entities.ownListing[id]?.attributes
                    ?.availabilityPlan?.timezone;
            const includedTimeZone = rest?.availabilityPlan?.timezone;

            // Note: if update values include stockUpdate, we'll do that first
            // That way we get updated currentStock info among ownListings.update

            return sdk.ownListings.update(ownListingUpdateValues, queryParams)
                .then(response => {
                    dispatch(updateListingSuccess(response));
                    dispatch(resetDeletedImageIds());

                    if (isPhotoTabSubmission) {
                        // Delete removed images from Cloudinary — fire-and-forget
                        deletedCloudinaryPublicIds.forEach(publicId => {
                            if (publicId) {
                                deleteImage({ publicId })
                                    .catch(err => console.error(`Cloudinary delete failed for ${publicId}:`, err));
                            }
                        });

                        // Sync Cloudinary context for all surviving images — fire-and-forget
                        const savedListingImages = updatedPublicData.listingImages || [];
                        savedListingImages.forEach(img => {
                            if (img.seoTags && img.public_id) {
                                updateCloudinaryContext({ publicId: img.public_id, context: img.seoTags })
                                    .catch(err => console.error(`Cloudinary context update failed for ${img.public_id}:`, err));
                            }
                        });
                    }

                    dispatch(markTabUpdated(tab));

                    // If there were partial failures, show warning after brief delay
                    if (partialFailureWarning) {
                        setTimeout(() => {
                            dispatch(updateListingError(storableError({
                                message: partialFailureWarning
                            })));
                        }, 500);
                    }

                    // remove tab updated after 3 seconds
                    setTimeout(() => {
                        dispatch(markTabUpdated(null));
                    }, 3000);

                    const denormalisedResponse = denormalisedResponseEntities(response)[0];
                    dispatch(showListingsSuccess(denormalisedResponse));
                    dispatch(addMarketplaceEntities(response));
                    const filteredAvailabilityExceptions = availabilityExceptions?.filter(exception => exception.start && exception.end);
                    if (filteredAvailabilityExceptions && filteredAvailabilityExceptions.length > 0) {
                        Promise.all(
                            filteredAvailabilityExceptions.map(exception =>
                                sdk.availabilityExceptions.create({
                                    listingId: id,
                                    start: new Date(exception.start),
                                    end: new Date(exception.end),
                                    seats: exception.seats,
                                })
                            )
                        )
                            .then(() => {
                                fetchLoadDataExceptions(dispatch, denormalisedResponse);
                            })
                    };

                    // Save to Algolia
                    const {
                        title = '',
                        description = '',
                        price,
                        state,
                        geolocation,
                        availabilityPlan = '',
                        createdAt,
                        publicData = {},
                        metadata = {},
                    } = response.data.data.attributes || {};

                    if (state == 'published') {
                        createAlgoliaData({
                            indexName: getAlgoliaIndexNameForLang(language),
                            objectID: id,
                            state,
                            _geoloc:
                                geolocation && geolocation.lat
                                    ? { lat: geolocation.lat, lng: geolocation.lng }
                                    : {},
                            title,
                            description: description.slice(0, 999),
                            price,
                            availabilityPlan,
                            publicData: {
                                ...filterPublicDataToAlgolia(publicData, LISTING_ALOGLIA_REMOVABLE_FIELDS),
                            },
                            metadata,
                            user: {
                                id: currentUser.id.uuid,
                                firstName,
                                lastName,
                                email,
                                displayName,
                                publicData: filterListingUserPublicDataForAlgolia(userPublicData),
                            },
                            createdAt,
                            timestamp: moment(createdAt).unix(),
                            order: publicData.order,
                        });

                        // createAlgoliaData only pushes to the current-UI-language index.
                        // Sync all 4 locale indices with locale-correct hierarchy strings so
                        // FR/ES/ZH visitors see the right store category breadcrumbs immediately.
                        if (publicData.storeCategoryId) {
                            syncListingAlgolia(id).catch(err =>
                                console.error('syncListingAlgolia after update failed:', err)
                            );
                        }
                    }

                    // If time zone has changed, we need to fetch exceptions again
                    // since week and month boundaries might have changed.
                    if (!!includedTimeZone && includedTimeZone !== existingTimeZone) {
                        const searchString = '';
                        const firstDayOfWeek = config.localization.firstDayOfWeek;
                        const listing = response.data.data;
                        fetchLoadDataExceptions(
                            dispatch,
                            listing,
                            searchString,
                            firstDayOfWeek
                        );
                    }

                    return response;
                })
                .catch(e => {
                    console.error(e, 'update-listing-failed', { listingData: data });
                    return dispatch(updateListingError(storableError(e)));
                });

        } catch (error) {
            // Catch any errors from image processing or other operations
            console.error('Failed to update listing:', error);
            dispatch(updateListingError(storableError(error)));
            throw error;  // Re-throw for caller to handle
        }
    };
};

export const requestPublishListingDraft = (listingId, config, language) => (
    dispatch,
    getState,
    sdk
) => {
    // Log the listing ID and its type for debugging
    console.log(
        'Publishing listing with ID:',
        listingId,
        'Type:',
        typeof listingId
    );

    // Ensure listingId is a string
    const id = listingId?.uuid || listingId;
    console.log('Using listing ID for publish:', id);

    // First, validate that the listing has images before publishing
    return sdk.ownListings
        .show({
            id, include: ['images'], 'fields.image': [
                'variants.scaled-small']
        })
        .then(response => {
            const listing = response.data.data;
            const images = (response.data.included || []).filter(inc => inc != null && inc.type === 'image');
            const listingImages = listing.attributes?.publicData?.listingImages || [];
            // Validate that listing has at least one image
            if (images.length === 0 && listingImages.length === 0) {
                throw new Error('Cannot publish listing without images. Please add at least one image.');
            }

            console.log('Listing has images, proceeding to publish');
            dispatch(publishListingRequest(id));

            // Log the SDK method being called
            console.log(
                'Calling sdk.ownListings.publishDraft with:',
                { id },
                { expand: true }
            );

            return sdk.ownListings.publishDraft({ id }, { expand: true });
        })
        .then(response => {
            // Add the created listing to the marketplace data
            dispatch(addMarketplaceEntities(response));
            dispatch(publishListingSuccess(response));

            // Save to Algolia
            const applicationState = getState();
            const { currentUser } = applicationState.user;
            const { email, createdAt: userCreatedAt } = currentUser?.attributes || {};

            // Need to cancel the 1 hour scheduled email if the listing is published
            // If the updated withing 1 hour
            const isWithin1Hour = moment().diff(userCreatedAt, 'minutes') < 60;
            if (isWithin1Hour) {
                cancelUpcomingMail({});
            }

            const {
                firstName,
                lastName,
                displayName,
                publicData: userPublicData = {},
                protectedData: userProtectedData = {},
            } = currentUser.attributes.profile;

            const { phoneNumber, notificationSettings } = userProtectedData || {};
            const { accountActivitySms } = notificationSettings || {};

            const {
                title = '',
                description = '',
                price,
                state,
                geolocation,
                availabilityPlan = '',
                createdAt,
                publicData = {},
                metadata = {},
            } = response.data.data.attributes || {};
            // console.log(state, '&&& &&& => state');

            if (state == 'published') {
                // We have to know the position of listing
                // to define its default initial order.
                // It will be "total listings"
                sdk.ownListings.query().then(({ data }) => {
                    const { meta } = data || {};
                    const totalItems = meta?.totalItems;
                    const defaultOrder = totalItems ? totalItems : 0;


                    createAlgoliaData({
                        indexName: getAlgoliaIndexNameForLang(language),
                        objectID: listingId.uuid,
                        state,
                        _geoloc:
                            geolocation && geolocation.lat
                                ? { lat: geolocation.lat, lng: geolocation.lng }
                                : {},
                        title,
                        description: description.slice(0, 999),
                        price,
                        availabilityPlan,
                        publicData: {
                            ...filterPublicDataToAlgolia(publicData, LISTING_ALOGLIA_REMOVABLE_FIELDS),
                        },
                        metadata,
                        user: {
                            id: currentUser.id.uuid,
                            firstName,
                            lastName,
                            email,
                            displayName,
                            publicData: filterListingUserPublicDataForAlgolia(userPublicData),
                        },
                        createdAt,
                        timestamp: moment(createdAt).unix(),
                        order: defaultOrder,
                    });

                    // Sync all 4 locale Algolia indices with locale-correct store category hierarchy.
                    if (publicData.storeCategoryId) {
                        syncListingAlgolia(listingId.uuid).catch(err =>
                            console.error('syncListingAlgolia after first publish failed:', err)
                        );
                    }

                    // Send SMS Notification and Email
                    // console.log(phoneNumber, accountActivitySms, 'phoneNumber, accountActivitySms');
                    // if (phoneNumber && accountActivitySms && !IS_DEVELOPMENT_ENV) {
                    //     sendSMSNotification({
                    //         to: phoneNumber,
                    //         contentSid: listingSmsNotificationContentSid,
                    //         contentVariables: {
                    //             owner_name: firstName,
                    //             item_name: title,
                    //             listing_link: `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/rentals/${createSlug(title)}/${id}`,
                    //         },
                    //     });
                    // }
                    // Update in sharetribe
                    sdk.ownListings.update({
                        id: listingId.uuid,
                        publicData: {
                            order: defaultOrder,
                            publishedAt: new Date().toISOString()
                        },
                    });
                });

                // Create user record in Algolia when he first time
                // publish his listing. Need to know the total active
                // listings so his store can be ranked.
                userActiveListings(currentUser.id.uuid).then(res => {
                    const { totalListings } = res.data || {};

                    // If this is the first listing and user doesn't have location, copy from listing
                    if (totalListings === 1) {
                        const hasUserLocation = userPublicData.address &&
                            userPublicData.origin?.lat &&
                            userPublicData.origin?.lng;

                        if (!hasUserLocation) {
                            const listingLocation = publicData?.location?.address;
                            const listingCity = publicData?.city;
                            const listingCountry = publicData?.country;
                            const listingPostcode = publicData?.postcode;
                            const listingState = publicData?.state || publicData?.region;
                            const listingOrigin = geolocation;

                            if (listingLocation && listingOrigin) {
                                // Update user profile with listing location
                                sdk.currentUser.updateProfile({
                                    publicData: {
                                        address: listingLocation,
                                        ...(listingCity && { city: listingCity }),
                                        ...(listingCountry && { country: listingCountry }),
                                        ...(listingPostcode && { postcode: listingPostcode }),
                                        ...(listingState && { state: listingState }),
                                        origin: {
                                            lat: listingOrigin.lat,
                                            lng: listingOrigin.lng
                                        }
                                    }
                                })
                                    .then(() => {
                                        console.log('User profile updated with first listing location');
                                    })
                                    .catch(err => {
                                        console.error('Failed to update user profile with location:', err);
                                    });
                            }
                        }
                    }

                    // User
                    createAlgoliaData({
                        indexName: process.env.REACT_APP_ALGOLIA_USERS_INDEX,
                        objectID: currentUser.id.uuid,
                        _geoloc:
                            userPublicData.origin?.lng && userPublicData.origin?.lat
                                ? {
                                    lat: userPublicData.origin.lat,
                                    lng: userPublicData.origin.lng,
                                }
                                : {},
                        firstName,
                        lastName,
                        displayName,
                        email,
                        publicData: {
                            ...filterUserPublicDataForAlgolia(userPublicData),
                            totalListings,
                        },
                        ...(userPublicData.profileImage
                            ? { profileImage: userPublicData.profileImage }
                            : {}),
                        createdAt: userCreatedAt,
                        timestamp: moment(userCreatedAt).unix(),
                    });
                });
            }

            return response;
        })
        .catch(e => {
            console.error('Failed to publish listing:', e);
            dispatch(publishListingError(storableError(e)));
            throw e;  // Re-throw to ensure promise rejects properly
        });
};


export const requestGenerateAIImages = ({ listingId, ...params }) => async (dispatch, getState, sdk) => {
    try {
        dispatch(generateAIImagesRequest(listingId));
        const { images, remainingCredits } = await generateAIImages(params);
        const dataToSave = images.map(image => ({
            secure_url: image.imageUrl,
            public_id: image.publicId,
            height: image.height,
            width: image.width,
        }));
        dispatch(getCreditsSuccess(remainingCredits));
        dispatch(generateAIImagesSuccess(images, listingId));

        // Persist the most recently generated image to Sharetribe (replaces any previous).
        // Non-fatal: images are already in Redux; a persistence failure is logged but not surfaced.
        if (listingId) {
            try {
                await sdk.ownListings.update({
                    id: listingId,
                    publicData: { generatedImages: dataToSave },
                });
            } catch (persistError) {
                console.error('Failed to persist generated images to Sharetribe:', persistError);
            }
        }
        return images;
    } catch (error) {
        dispatch(generateAIImagesError(error, listingId));
        // Refresh credits in case the backend deducted one before returning an error.
        if (params.listingToken) {
            dispatch(requestGetCredits(params.listingToken)).catch(() => {});
        }
        throw error;
    }
};

// Clears in-session generated images from Redux and removes them from Sharetribe publicData
// so the AI card doesn't resurface a dismissed or consumed image on the next page load.
export const requestClearGeneratedImages = (listingId) => async (dispatch, _getState, sdk) => {
    dispatch(resetGeneratedImages());
    if (!listingId) return;
    try {
        await sdk.ownListings.update({
            id: listingId,
            publicData: { generatedImages: [] },
        });
    } catch (e) {
        // Non-fatal — Redux is already cleared; persistence failure is not surfaced to the user.
        console.error('Failed to clear generatedImages from Sharetribe publicData:', e);
    }
};


// ================ Blog Actions ================ //

// Thunks
export const fetchBlogsByListingId = listingId => async dispatch => {
    dispatch(fetchBlogsRequest());
    try {
        const result = await getBlogsByListingId(listingId);
        dispatch(fetchBlogsSuccess(result.data || []));
    } catch (e) {
        dispatch(fetchBlogsError(e));
    }
};

export const requestUpdateBlog = (id, update) => async dispatch => {
    dispatch(updateBlogRequest(id));
    const locale = typeof window !== 'undefined' ? localStorage.getItem('appLanguage') : 'en';
    update.locale = locale;

    try {
        const result = await updateBlogPost(id, update);
        dispatch(updateBlogSuccess(result.data));
    } catch (e) {
        dispatch(updateBlogError(id, e));
    }
};

export const requestDeleteBlog = id => async dispatch => {
    dispatch(deleteBlogRequest(id));
    try {
        await deleteBlogPost(id);
        dispatch(deleteBlogSuccess(id));
    } catch (e) {
        dispatch(deleteBlogError(id, e));
    }
};

export const requestPublishBlog = id => async dispatch => {
    dispatch(publishBlogRequest(id));
    try {
        const result = await publishBlogPost(id);
        dispatch(publishBlogSuccess(result.data));
    } catch (e) {
        dispatch(publishBlogError(id, e));
    }
};

export const requestRetryBlogTranslations = id => async dispatch => {
    dispatch(retryBlogTranslationsRequest(id));
    try {
        const result = await retryBlogTranslations(id);
        const maybe = result?.data || result;
        const updated = maybe && maybe.data ? maybe.data : maybe;
        const hasTranslations =
            !!updated?.translations &&
            typeof updated.translations === 'object' &&
            Object.keys(updated.translations).length > 0;
        const status =
            hasTranslations || updated?.translationsStatus === 'succeeded'
                ? 'completed'
                : 'in_progress';
        dispatch(retryBlogTranslationsSuccess(id, updated, status));
        return updated;
    } catch (e) {
        dispatch(retryBlogTranslationsError(id, e));
        throw e;
    }
};

// Thunk for generating blog titles
export const requestGenerateBlogTitles = params => async dispatch => {
    dispatch(generateBlogTitlesRequest());
    try {
        // You may need to adjust the API endpoint and payload as per your backend
        const { data } = await generateBlogTitleswithLabels(params);
        dispatch(generateBlogTitlesSuccess(data.blogTitles));
        return data.blogTitles;
    } catch (error) {
        dispatch(generateBlogTitlesError(error));
    }
};

export const requestGenerateBlogs = params => async dispatch => {
    dispatch(generateBlogsRequest());
    const locale = typeof window !== 'undefined' ? localStorage.getItem('appLanguage') : 'en';
    params.locale = locale;

    try {
        const { data } = await generateBlogs(params);
        dispatch(generateBlogsSuccess(data));
        return data;
    } catch (error) {
        dispatch(generateBlogsError(error));
    }
};

export const dismissMigrationBanner = listingId => async (dispatch, _getState, sdk) => {
    dispatch({ type: DISMISS_MIGRATION_BANNER_REQUEST });
    try {
        await sdk.ownListings.update({
            id: listingId,
            publicData: { aiMigrationBannerDismissed: true },
        });
        dispatch({ type: DISMISS_MIGRATION_BANNER_SUCCESS, payload: listingId });
    } catch (err) {
        dispatch({ type: DISMISS_MIGRATION_BANNER_ERROR, payload: storableError(err) });
        // Do not re-throw — UI already dismissed optimistically
    }
};

/**
 * Checks listing.publicData.listingImages for items missing seoTags.
 * Generates tags from listing attributes for untagged items only.
 * Saves the full updated listingImages array to Sharetribe publicData.
 * Writes to Cloudinary context for each newly tagged image (fire-and-forget).
 * This thunk is non-blocking and non-critical — failures are logged only.
 */
export const ensureListingImageSeoTags = listing =>
    async (dispatch, getState, sdk) => {
        const listingImages = listing.attributes?.publicData?.listingImages || [];

        const untagged = listingImages.filter(img => !img.seoTags);
        console.log('untagged :>> ', untagged);
        if (untagged.length === 0) return;

        const storeName = getState().user.currentUser?.attributes?.profile?.publicData?.storeName || '';

        const updatedListingImages = listingImages.map((img, idx) => {
            if (img.seoTags) return img;
            return {
                ...img,
                seoTags: buildListingImageSeoTags(listing, idx, storeName),
            };
        });

        try {
            await sdk.ownListings.update({
                id: listing.id,
                publicData: { listingImages: updatedListingImages },
            });
        } catch (err) {
            console.warn('ensureListingImageSeoTags: Sharetribe update failed:', err.message);
            return;
        }

        console.log('updatedListingImages :>> ', updatedListingImages);

        updatedListingImages.forEach(img => {
            if (img.seoTags && img.public_id) {
                updateCloudinaryContext({ publicId: img.public_id, context: img.seoTags })
                    .catch(err => console.error('Cloudinary context update failed:', err));
            }
        });
    };

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
    dispatch(clearUpdatedTab());
    const { listingId: id, tab } = params || {};

    // Preserve in-session generated images when the user switches tabs within the same listing.
    // Only reset when opening a different listing or when no images have been generated yet.
    const aiState = getState().AIUpdateListingPage;
    const hasImagesForThisListing =
        aiState.generatedImages?.length > 0 && aiState.activeListingId === id;
    if (!hasImagesForThisListing) {
        dispatch(resetGeneratedImages());
    }

    // deletedImageIds tracks photo deletions the user hasn't saved yet. It must not leak
    // across listings — otherwise an unsaved delete on one listing can silently strip an
    // image from a completely unrelated listing's next successful update.
    const isSameListingAsBefore = aiState.listing?.id?.uuid === id;
    if (!isSameListingAsBefore && aiState.deletedImageIds?.length > 0) {
        dispatch(resetDeletedImageIds());
    }

    if (!id) {
        return Promise.reject(new Error('loadData: missing listingId in route params'));
    }

    const payload = { id: new UUID(id) };

    const listingResponse = await dispatch(requestShowListing(payload, config))
    const listing = listingResponse?.data?.data;

    if (listing) {
        // Fire-and-forget — does not block page render
        dispatch(ensureListingImageSeoTags(listing));
    }

    const promises = [];
    promises.push(dispatch(getAdminConfig()));
    // If current tab is 'blogs', fetch blog titles
    if (tab === 'blogs' && listing?.attributes?.state === 'published') {
        // You may want to pass additional params as needed
        promises.push(dispatch(fetchBlogsByListingId(id)));
        promises.push(dispatch(requestGenerateBlogTitles({ listingTitle: listing.attributes.title, location: listing.attributes.publicData.city || listing.attributes.publicData.location?.address, locale: listing.attributes.publicData.defaultLanguage })));
    };

    const transactionProcessAlias =
        listing?.attributes?.publicData?.transactionProcessAlias;
    if (listing && isBookingProcessAlias(transactionProcessAlias)) {
        promises.push(fetchLoadDataExceptions(
            dispatch,
            listing,
            search,
            config.localization.firstDayOfWeek
        ));
    }
    const currentUser = getState().user.currentUser;
    if (currentUser && currentUser.stripeAccount) {
        promises.push(dispatch(fetchStripeAccount()));
    };

    const listingToken = listing?.attributes?.publicData?.listingToken;
    if (listingToken && listingToken.length > 0) {
        promises.push(dispatch(requestGetCredits(listingToken)));
    };

    return Promise.all(promises);
};
